import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'

const avatarAppear = keyframes`
  from {
    opacity: 0,
    transform: scale(0),
  }

  to {
    opacity: 1,
    transform: scale(1),
  }  
`

export default makeStyles()(theme => ({
  wrapper: {
    width: 192,
    height: 192,
    margin: `0 auto ${theme.spacing(6)} auto`,
    [theme.breakpoints.down('md')]: {
      width: 144,
      height: 144,
      margin: `0 auto ${theme.spacing(4)} auto`,
    },
    [theme.breakpoints.down('sm')]: {
      width: 96,
      height: 96,
    },
  },
  container: {
    position: 'relative',
  },
  avatar: {
    width: '192px !important',
    height: '192px !important',
    margin: `0 auto ${theme.spacing(4)} auto`,
    backgroundColor: '#FFF',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.55)',
    animation: `${avatarAppear} 0.5s cubic-bezier(0.7, 0, 0, 1)`,
    animationDelay: '0.16s',
    animationFillMode: 'backwards',
    zIndex: '3',
    [theme.breakpoints.down('md')]: {
      width: '144px !important',
      height: '144px !important',
    },
    [theme.breakpoints.down('sm')]: {
      width: '96px !important',
      height: '96px !important',
    },
  },
  fab: {
    color: 'white !important',
    position: 'absolute !important' as 'absolute',
    left: 'calc(50% + 40px)',
    top: 'calc(50% + 40px)',
    zIndex: '4',
    animation: 'avatar-appear 0.5s cubic-bezier(0.7, 0, 0, 1)',
    animationDelay: '0.32s',
    animationFillMode: 'backwards',
    border: '1px solid rgba(255, 255, 255, 0.4) !important',
    [theme.breakpoints.down('md')]: {
      left: 'calc(50% + 28px)',
      top: 'calc(50% + 28px)',
    },
    [theme.breakpoints.down('sm')]: {
      left: 'calc(50% + 10px)',
      top: 'calc(50% + 10px)',
    },
  },
  error: {
    color: 'rgb(244, 67, 54)',
    position: 'absolute',
    top: 'calc(50% - 7px)',
    left: '0',
    width: '100%',
    textAlign: 'center',
    zIndex: '3',
    textShadow: `0 0 1px ${'#FFF'}`,
    filter: `drop-shadow(0 0 2px ${'#FFF'})`,
  },
}))
